export const AI = 'ai';
export const INFO = 'info';
export const SUCCESS = 'success';
export const WARNING = 'warning';
export const ERROR = 'error';
export const DOWNLOAD = 'download';
export const LOADING = 'loadingSpinner';
